import { useState } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Authentication from'./components/Authentication.js';
import Nav from'./components/Nav.js';
import Header from'./components/Header.js';
import Footer from'./components/Footer.js';
import Home from'./screens/Home.js';
import Profile from'./screens/Profile.js';
import Logout from'./screens/Logout.js';
import ForgotPassword from'./screens/ForgotPassword.js';
import NotFound from'./screens/NotFound.js';

function App() {
	const [user, setUser] = useState(false);
  
	return (
	  <Router>
		<div className="screen">
		  <Nav user={user} />
		  <Header user={user} />
  
		  <main className="mc-content uk-animation-slide-bottom flex-1">
			<Switch>
			  <Route path="/forgot-password">
				<ForgotPassword />
			  </Route>
  
			  <Route>
				<Authentication user={user} setUser={setUser}>
				  <Switch>
					<Route exact path="/"><Home /></Route>
					<Route exact path="/profile"><Profile user={user} setUser={setUser} /></Route>
					<Route exact path="/logout"><Logout setUser={setUser} /></Route>
					<Route><NotFound /></Route>
				  </Switch>
				</Authentication>
			  </Route>
			</Switch>
		  </main>
  
		  <Footer />
		</div>
	  </Router>
	);
  }
  

export default App;
